export const canUserViewFeature = (bondsman, feature, allowedTypes = [], isOnlyOwner) => {
  if (!bondsman) return false
  const { employee_type: type, restrictedPermissions, employee_permissions } = bondsman
  if (isOnlyOwner) {
    if (['OWNER','SUPER'].indexOf(type) >= 0) {
      return true
    }
    return false
  }
  if ([...allowedTypes, 'SUPER'].indexOf(type) >= 0) return true
  let canViewFeature = true
  if (restrictedPermissions.indexOf(feature) >= 0) {
    canViewFeature = false
    if (employee_permissions.indexOf(feature) >= 0) {
      canViewFeature = true
    }
  }
  return canViewFeature
}

export const hasFeature = (bondsman, features) => {
  let hasFeature = false
  if (features.length === 0) return true 
  features.forEach(f => {
    if (bondsman.features.indexOf(f) >= 0) hasFeature = true
  })
  return hasFeature
}

export const PERMISSIONS = [
  {
    type: "MENU_ITEMS",
    title: "Menu Items",
    features: [],
    options: [
      {
        type: 'SETTINGS',
        title: 'Settings',
        description: 'Allows this user to access the Settings Page.',
        descriptionAlt: 'Toggling this on will remove the ability for users to access the Settings Page.',
        features: []
      }
    ]
  }
  // {
  //   type: "AGENCY",
  //   title: "AGENCY",
  //   features: [],
  //   options: [
  //     {
  //       type: 'REVIEWER',
  //       title: 'Reviewer',
  //       description: 'Allows this user to be selected to Review an Application.',
  //       descriptionAlt: 'Toggling this on will remove the ability for all users to be able to Review an Application.',
  //       features: []
  //     }
  //   ]
  // }
]

export const USER_TYPES = {
  'OWNER': 'Owner',
  'PERMISSIONS': 'User',
}